import classnames from 'classnames';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { WithDbId } from '../../../../adl-gen/common/db';
import {
  UploadState_Error,
  UploadState_Ok,
  UploadState_Warning,
  UserUploadRecord
} from '../../../../adl-gen/totalinteraction/futurefit/db';
import { UserUploadData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Table, TableCell, TableRow } from '../../../../ui/widgets/table/table';
import { AppUserUploadStore, CSVField } from '../../../stores';
import { renderButtons } from '../../common/editor';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';

const styles = require('./appuser-upload-result-screen.css');
const fonts = require('../../../../ui/common/fonts.css');

type StateMessageType = UploadState_Error | UploadState_Warning | UploadState_Ok;

interface AppUserUploadResultScreenProps {
  pageLayout: AdminPageLayoutFn;

  store: AppUserUploadStore;

  // result: MaybeLoading<UserUploadResult>
  data: MaybeLoading<Paginated<WithDbId<UserUploadRecord>>>;

  onCancel?(): Promise<void>;
}

@observer
export class AppUserUploadResultScreen extends React.Component<AppUserUploadResultScreenProps> {
  @observable data?: UserUploadData;

  get uploadFields() {
    return this.props.store.fields;
  }

  onCancel = async () => {
    if (this.props.onCancel) {
      await this.props.onCancel();
    }
  };

  renderField = (field: CSVField, index: number, data?: UserUploadRecord, className?: string) => {
    let content = null;
    if (data) {
      switch (field.name) {
        // TODO: Use userUploadFields
        case 'assessment_1':
          content = data.quizTitlesEn[0];
          break;
        case 'assessment_2':
          content = data.quizTitlesEn[1];
          break;
        case 'assessment_3':
          content = data.quizTitlesEn[2];
          break;
        case 'group_1':
          content = data.userGroupNames[0];
          break;
        case 'group_2':
          content = data.userGroupNames[1];
          break;
        case 'group_3':
          content = data.userGroupNames[2];
          break;
        case 'group_4':
          content = data.userGroupNames[3];
          break;
        case 'group_5':
          content = data.userGroupNames[4];
          break;
        default:
          content = data[field.name];
      }
    }
    return (
      <TableCell key={index}>
        <span className={className ? classnames(className, fonts.caption) : fonts.caption}>{content}</span>
      </TableCell>
    );
  };

  renderMessages = (messages: StateMessageType[], key: number, className: string) => {
    return (
      <TableCell key={key}>
        {messages.map((text, idx) => (
          <p key={key + '.' + idx} className={classnames(className, fonts.caption)}>
            {`${text.value.fieldName}: ${text.value.message}`}
          </p>
        ))}
      </TableCell>
    );
  };

  renderRowAndMessages = (
    colInfo: CSVField[],
    row: UserUploadRecord,
    messages: StateMessageType[],
    className: string
  ) => {
    return [...this.renderDataRow(colInfo, row, className), this.renderMessages(messages, colInfo.length, className)];
  };

  renderRow = (colInfo: CSVField[], row: UserUploadRecord) => {
    const errors = row.state.filter(s => s.kind === 'error');
    const warnings = row.state.filter(s => s.kind === 'warning');
    const messages: StateMessageType[] = row.state.reduce((acc: StateMessageType[], s) => {
      if (s.kind === 'error' || s.kind === 'warning') {
        //||s.kind === "ok") {
        acc.push(s);
      }
      return acc;
    }, []);
    let className = styles.okText;
    if (errors.length > 0) {
      className = styles.errorText;
    } else if (warnings.length > 0) {
      className = styles.warningText;
    }
    return this.renderRowAndMessages(colInfo, row, messages, className);
  };

  renderDataRow = (colInfo: CSVField[], row: UserUploadRecord, className?: string) => {
    return colInfo.map((field, idx) => {
      return this.renderField(field, idx, row, className);
    });
  };

  renderData = observer((data: Paginated<WithDbId<UserUploadRecord>>) => {
    return (
      <React.Fragment>
        <div>{renderButtons(undefined, undefined, this.props.onCancel, undefined, undefined, () => true)}</div>
        <Table>
          <TableRow header>
            {this.uploadFields.map((field, idx) => {
              return (
                <TableCell key={idx}>
                  <div>{field.label}</div>
                </TableCell>
              );
            })}
            <TableCell>
              <div>ERRORS/WARNINGS/MESSAGES</div>
            </TableCell>
          </TableRow>
          {data.items.map((row, idx) => {
            return <TableRow key={idx}>{...this.renderRow(this.uploadFields, row.value)}</TableRow>;
          })}
        </Table>
      </React.Fragment>
    );
  });

  ReportResultsLoader = () => {
    const { data } = this.props;
    return <Loader state={data} LoadedComponent={this.renderData} />;
  };

  render() {
    return (
      <this.props.pageLayout title={'Administration - Bulk User Upload'}>
        <this.ReportResultsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/appuser-upload-screen/appuser-upload-result-screen.tsx